// extracted by mini-css-extract-plugin
export default {"privacyContent":"PrivacyModal_privacyContent_PT87C","section":"PrivacyModal_section_Vja3B","actions":"PrivacyModal_actions_RkpMV","closeButton":"PrivacyModal_closeButton_KUSyO"};